import { GRID_AGGREGATION_FUNCTIONS } from '@mui/x-data-grid-premium';
import { memoReasons } from '@shared/constants/ReceiptMemos';
import Money from 'shared/utils/Money';
import BoldHeader from 'src/components/atoms/grid/BoldHeader';
import { AgCollapsibleCard, AgText } from 'src/components/ui';
import { DataGrid, GridColObj } from 'src/modules/grids';
import { totalsLabelAggregation } from 'src/utils/grid/column/columnAggregation';

import { CustomerPortalInvoice } from './useCustomerPortalInvoice';

type Props = { invoice: CustomerPortalInvoice };

const creditColumns: GridColObj = {
  reason: {
    headerName: 'Reason',
    flex: 1,
    valueGetter: (value) => memoReasons.find((reason) => reason.code === value)?.label,
    renderHeader: BoldHeader,
    renderCell: ({ value, rowNode }) => {
      if (rowNode.isAutoGenerated)
        return (
          <AgText size="12" className="uppercase tracking-wider">
            {value}
          </AgText>
        );
      return value;
    },
  },
  amount: {
    headerName: 'Amount',
    type: 'number',
    flex: 1,
    renderHeader: BoldHeader,
    valueGetter: (value) => Money.toHuman(value),
  },
  memo: { headerName: 'Memo', flex: 1, renderHeader: BoldHeader },
};

export default function InvoiceCredits({ invoice }: Props) {
  return (
    <AgCollapsibleCard title="Credits">
      <DataGrid
        rows={invoice.adjustments}
        columns={creditColumns}
        gridKey="customer-portal.invoice.credits"
        storageKey="invoice-credits"
        variant="list"
        gridId="credits"
        hideFooter
        aggregationFunctions={{ ...GRID_AGGREGATION_FUNCTIONS, totals: totalsLabelAggregation }}
        disableAggregation={invoice.adjustments.length < 2}
        initialState={{ aggregation: { model: { type: 'totals', amount: 'sum' } } }}
      />
    </AgCollapsibleCard>
  );
}
